import api from './api.js';

export const notificationService = {
  // Get all notifications
  getNotifications: (params = {}) => api.get('/communication/notifications', { params }),
  
  // Get notification by ID
  getNotification: (id) => api.get(`/communication/notifications/${id}`),
  
  // Mark notification as read
  markAsRead: (id) => api.put(`/communication/notifications/${id}/read`),
  
  // Mark notification as unread
  markAsUnread: (id) => api.put(`/communication/notifications/${id}/unread`),
  
  // Mark all notifications as read
  markAllAsRead: () => api.put('/communication/notifications/read-all'),
  
  // Delete notification
  deleteNotification: (id) => api.delete(`/communication/notifications/${id}`),
  
  // Delete all notifications
  deleteAllNotifications: () => api.delete('/communication/notifications/delete-all'),
  
  // Get unread notifications
  getUnreadNotifications: (params = {}) => 
    api.get('/communication/notifications/unread', { params }),
  
  // Get read notifications
  getReadNotifications: (params = {}) => 
    api.get('/communication/notifications/read', { params }),
  
  // Get notifications by type
  getNotificationsByType: (type, params = {}) => 
    api.get(`/communication/notifications/type/${type}`, { params }),
  
  // Get notification count
  getNotificationCount: () => api.get('/communication/notifications/count'),
  
  // Get unread count
  getUnreadCount: () => api.get('/communication/notifications/unread-count'),
  
  // Create notification (admin/teacher only)
  createNotification: (data) => api.post('/communication/notifications', data),
  
  // Update notification (admin/teacher only)
  updateNotification: (id, data) => api.put(`/communication/notifications/${id}`, data),
  
  // Bulk create notifications (admin/teacher only)
  bulkCreateNotifications: (data) => api.post('/communication/notifications/bulk', data),
  
  // Get notification preferences
  getNotificationPreferences: () => api.get('/communication/notifications/preferences'),
  
  // Update notification preferences
  updateNotificationPreferences: (data) => 
    api.put('/communication/notifications/preferences', data),
  
  // Get notification history
  getNotificationHistory: (params = {}) => 
    api.get('/communication/notifications/history', { params }),
  
  // Get notification analytics (admin only)
  getNotificationAnalytics: (params = {}) => 
    api.get('/communication/notifications/analytics', { params }),
  
  // Get notification templates (admin only)
  getNotificationTemplates: () => api.get('/communication/notifications/templates'),
  
  // Create notification template (admin only)
  createNotificationTemplate: (data) => 
    api.post('/communication/notifications/templates', data),
  
  // Update notification template (admin only)
  updateNotificationTemplate: (id, data) => 
    api.put(`/communication/notifications/templates/${id}`, data),
  
  // Delete notification template (admin only)
  deleteNotificationTemplate: (id) => 
    api.delete(`/communication/notifications/templates/${id}`),
  
  // Send notification using template (admin/teacher only)
  sendNotificationFromTemplate: (templateId, data) => 
    api.post(`/communication/notifications/templates/${templateId}/send`, data),
  
  // Get notification delivery status
  getDeliveryStatus: (notificationId) => 
    api.get(`/communication/notifications/${notificationId}/delivery-status`),
  
  // Retry failed notification (admin only)
  retryNotification: (notificationId) => 
    api.post(`/communication/notifications/${notificationId}/retry`),
  
  // Get notification statistics
  getNotificationStats: (params = {}) => 
    api.get('/communication/notifications/stats', { params }),
  
  // Export notifications (admin only)
  exportNotifications: (params = {}) => 
    api.get('/communication/notifications/export', { 
      params, 
      responseType: 'blob' 
    }),
};
